<template>
  <div
    class="d-flex justify-content-between align-items-center"
    :class="[marginClass, containerClass]"
  >
    <strong v-if="label" :class="labelClass">{{ label }}</strong>
    <slot name="label" v-else></slot>
    <span :class="valueClass">
      <slot>{{ value }}</slot>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  value: {
    type: [String, Number],
    default: ''
  },
  labelClass: {
    type: String,
    default: ''
  },
  valueClass: {
    type: String,
    default: ''
  },
  containerClass: {
    type: String,
    default: ''
  },
  noMargin: {
    type: Boolean,
    default: false
  }
});

const marginClass = computed(() => props.noMargin ? '' : 'mb-2');
</script>
